import { createContext, useContext, useMemo } from "react";
import useSWR from "swr";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: {}, loading: true });

const fetcher = (url) => api.get(url).then((r) => r.data);

export function SettingsProvider({ children }) {
  const { data, isLoading } = useSWR("/settings", fetcher, { revalidateOnFocus: false });
  const value = useMemo(() => ({ settings: data || {}, loading: isLoading }), [data, isLoading]);
  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
